const Task = require('../../model/Task');
const TableState = require('../../model/TableState');
const SubTask = require('../../model/SubTask');
const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const { permissions } = require('../../constants/permissions');

class TasksPersistenceService {
    constructor($rootScope, $filter, $q, crudService, sharedPersistenceService, sseService, storageService, utilsService, iamPersistenceService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this._$q = $q;
        this.crudService = crudService;
        this.sharedPersistence = sharedPersistenceService;
        this.iamPersistenceService = iamPersistenceService;
        this.sseService = sseService;
        this.storageService = storageService;
        this.utilsService = utilsService;
        this.REST_ENDPOINTS = this.sharedPersistence.getRestEndpoints();
        this.datetimeLocaleFormat = this.utilsService.getDateTimeLocaleFormat(true);


        this.$rootScope.$on("logout", () => {
            this.taskTableState = undefined;
            this.clearFilter();
            this.storageService.clearCustomPageSize('tasks');

        });
        this.$rootScope.$on("force-logout", () => {
            this.taskTableState = undefined;
            this.clearFilter();
            this.storageService.clearCustomPageSize('tasks');

        });
        this.$rootScope.$on("task.refresh", (event, data) => {
            if (!this.tasks.length) return;
            const taskData = Task.fromRaw(data);
            for (const task of this.tasks) {
                if (task.uuid === taskData.uuid) {
                    this.setTaskNewData(task, taskData, false);
                    break;
                }
                if (task.childTasks) {
                    for (const childTask of task.childTasks) {
                        if (childTask.uuid === taskData.uuid) {
                            this.setTaskNewData(childTask, taskData, true);
                            break;
                        }
                    }
                }

            }

            this.tasks = this.tasks;
        });

        this.setDefaults();
        this.initFilters();
    }

    setDefaults() {
        this.selectedTask = null;
        this.selectedTasks = [];
        this.TASKS_REST = this.sharedPersistence.getRestEndpoints().TASKS_REST;
        this.inProgressString = this.$filter('translate')('tasks.table.intaskProgress.text');
        this.pendingString = this.$filter('translate')('tasks.table.pending.text');
        this.pendingFinishedString = ' ';
        this.dateFilter = this.$filter('localizeDate');
        this.tasks = [];
    }

    initFilters() {
        this.filters = [];
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), Task.getResourceGroupsKey(), [], 'resourceGroups', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('event.filters.authority'), Task.getAuthorityKey(), [], 'authority', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('tasks.filters.type'), 'type', [], 'type', true));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('tasks.filters.status'), 'status', [], 'status'));
        let timeFilter = Filter.getTimeFilter(this.$filter('translate')('event.filters.timeRange'), Task.getTimeRangeKey(), Task.getTimeOptions(), 'timeRange');
        timeFilter.datetimeLocaleFormat = this.datetimeLocaleFormat;
        this.filters.push(timeFilter);
        this.filters.push(Filter.getHiddenFilter('', 'id', 'search', true, ['id']));

        this.updateFilters();
    }

    initDropdownFilters() {
        let resourceGroupsFilter;

        this.getAllResourceGroups().then(resourceGroups => {
            resourceGroupsFilter = this.filters.filter(item => item.filterKey === Task.getResourceGroupsKey())[0];
            if (!resourceGroupsFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), Task.getResourceGroupsKey(), [], 'resourceGroups', true));
                resourceGroupsFilter = this.filters.filter(item => item.filterKey === Task.getResourceGroupsKey())[0];
            }
            resourceGroupsFilter.originalList = resourceGroupsFilter.options = resourceGroups.map(
                (item, i) => {
                    return {
                        id: i,
                        label: item.label,
                        value: item.value
                    };
                });
        });
    }

    updateFilters() {
        let authorityFilter;

        this.sharedPersistence.getAllVmAdminAuthorities().then(authorities => {
            authorityFilter = this.filters.filter(item => item.filterKey === Task.getAuthorityKey())[0];

            if (!authorityFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('event.filters.authority'), TASK.getAuthorityKey(), [], 'authority'));
                authorityFilter = this.filters.filter(item => item.filterKey === Task.getAuthorityKey())[0];
            }

            authorityFilter.originalList = authorityFilter.options = this.updateFilterOptions(authorities, authorityFilter, 'authority');
        }
        );

        let typeFilter;
        this.getTypeOptions().then((taskTypes) => {
            typeFilter = this.filters.filter(item => item.filterKey === 'type')[0];
            if (!typeFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('event.filters.type'), 'type', [], 'type'));
                typeFilter = this.filters.filter(item => item.filterKey === 'type')[0];
            }

            typeFilter.originalList = typeFilter.options = this.updateFilterOptions(taskTypes, typeFilter, 'type');
        });


        let statusFilter;
        this.getStatusOptions().then((statusTypes) => {
            statusFilter = this.filters.filter(item => item.filterKey === 'status')[0];
            if (!statusFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('event.filters.status'), 'status', [], 'status'));
                statusFilter = this.filters.filter(item => item.filterKey === 'status')[0];
            }

            statusFilter.options = statusTypes;
        });

    }

    updateFilterOptions(items, filterItem, key) {
        let param = !key ? 'name' : key,
            selectedOptions = filterItem.selectedOptions ? filterItem.selectedOptions.map(item => item.value) : [];

        return items.map((item, i) => {
            return {
                id: i, label: item.label, value: item.value, group: item.group, selected: selectedOptions.indexOf(item[param]) > -1
            };
        }

        );
    }

    clearFilter() {
        if (this.taskTableState) this.taskTableState.page = 1;
        this.filters.forEach((filter) => {
            filter.clear();
        });
    }

    getAllResourceGroups() {
        return this.crudService.get(this.REST_ENDPOINTS.RESOURCE_GROUP_REST + '/dropDown', null, null, null, null, null, null, false).then(res => {
            return res.data.entities;
        });
    }

    getStatusOptions() {
        return this.crudService.get('taskStatuses').then((res) => {
            return res.data.entities;
        });
    }

    getTypeOptions() {
        return this.crudService.get('taskTypes').then((res) => {
            return res.data.entities;
        });
    }

    getTasks(firstPage, filters, isExport) {
        if (!this.iamPersistenceService.hasPermissions(permissions.TASK_LISTING)) {
            return this._$q((resolve) => { resolve([]); });
        }

        if (this.filters && this.filters[4] && typeof this.filters[4].setFilterByOptions === 'function') {
            this.filters[4].setFilterByOptions(this.filters[4]);
        }

        if (firstPage && this.taskTableState) {
            this.taskTableState.page = 1;
        }
        if (!this.taskTableState) {
            this.taskTableState = new TableState();
            this.taskTableState.orderBy = '-startTime';
            // check if custom pageSize is set
            let tempPageSize = this.storageService.getCustomPageSize('tasks');
            if (tempPageSize) {
                this.taskTableState.pageSize = tempPageSize;
            }
        }

        return this.crudService.getPagedWithStructuredFilter(this.TASKS_REST, this.taskTableState, this.filters, null, Task.getSearchKey(), null, isExport).then(res => {
            let searchBy = undefined;
            if (angular.isDefined(this.taskTableState.searchBy)) {
                searchBy = this.taskTableState.searchBy;
            }
            this.taskTableState = res.data.tableState;
            this.taskTableState.searchBy = searchBy;
            this.tasks = res.data.entities.map(Task.fromRaw);
            this.tasks.map(t => {
                this.setStartFinishedTime(t);
            });

            // set pageSize value
            if (this.taskTableState && this.taskTableState.pageSize) this.storageService.setCustomPageSize('tasks', this.taskTableState.pageSize);
            return this.tasks;
        });
    }

    getAllTasks(firstPage, searchBy, isExport) {
        let tableState = new TableState();
        tableState.pageSize = 1000000;
        if (searchBy) {
            tableState.searchBy = this.taskTableState.searchBy;
        }

        return this.crudService.getPagedWithStructuredFilter(this.TASKS_REST, tableState, this.filters, null, null, null, isExport).then(res => {
            let response = res.data.entities.map(Task.fromRaw);
            response.map(t => {
                this.setStartFinishedTime(t);
            });
            return response;
        });
    }

    getTaskDetails(task) {
        return this.crudService.get(this.TASKS_REST + `/${task.uuid}`).then(res => {
            const temp = Task.fromRaw(res.data.entities[0]);
            return this.setTaskNewData(task, temp);
        });
    }

    setStartFinishedTime(task) {
        task.startTime = this.getTimeString(task.startTime, true, task);
        task.createdTime = this.getTimeString(task.createdTime, null, task);
        task.finishTime = this.getTimeString(task.finishTime, true, task);
        task.timesConverted = true;
    }

    setTaskNewData(task, newData, isChildTask) {
        task.progress = newData.progress;
        task.startTime = newData.startTime;
        task.finishTime = newData.finishTime;
        task.createdTime = newData.createdTime;
        task.authorityEmail = newData.authorityEmail;
        task.target = newData.target;
        task.vmName = newData.vmName;
        task.status = newData.status;
        task.virtualMachineSnapshots = newData.virtualMachineSnapshots;
        this.setStartFinishedTime(task);
        task.childTasks = newData.childTasks;
        task.childTasks.forEach(childTask => {
            // if (childTask.status === "SKIPPED") {
            //     childTask.createdTime = this.getTimeString(task.createdTime);
            //     childTask.startTime = " ";
            //     childTask.finishTime = " ";
            // }
            // else {
            this.setStartFinishedTime(childTask);
            // }
        });
        task.subTasks = newData.subTasks;
        if (!isChildTask) {
            task.subTasks.forEach(subTask => {
                // if (subTask.status === "SKIPPED") {
                //     subTask.createdTime = this.getTimeString(task.createdTime);
                //     subTask.startTime = "/";
                //     subTask.finishTime = "/";
                //     console.log('timeset')
                // }
                // else {
                this.setStartFinishedTime(subTask);
                // }
            });
        }

        if (this.selectedTasks.length && this.selectedTasks[0].uuid === task.uuid) this.selectedTask = task;
        return task;
    }

    isIsoDate(str) {
        if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{1,3}/.test(str)) return false;
        return true;
    }

    getTimeString(time, start, task) {
        let queue = this.inProgressString;
        if (!time && (task.status === 'ABORTED' || task.status === 'ABORTING' || task.status === 'SKIPPED')) {
            return '/';
        }
        if (start) {
            queue = this.pendingString;
        }
        else if (!time) {
            queue = this.pendingFinishedString;
        }
        if (this.isIsoDate(time)) {
            return this.dateFilter(time, 'shortSec');
        } else {
            return queue;
        }
    }

    abortTask(task) {
        return this.crudService.get(this.TASKS_REST + '/' + task.uuid + '/abort');
    }

}

TasksPersistenceService.$inject = ['$rootScope', '$filter', '$q', 'crudService', 'sharedPersistenceService', 'sseService', 'storageService', 'utilsService', 'iamPersistenceService'];

module.exports = TasksPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/tasks/tasks.persistence.service.js